import Api from './Api';

class ForecastOrderServices {

	updateForeCastOrderMatrix = async (matrxId,data) =>
	await Api.put(`/accumulator/api/forecast-order/${matrxId}/`, data);

}
export default new ForecastOrderServices();
